<template>
  <div>
    <q-dialog :visible.sync="dialogVisible" title="摄影计划" :innerHeight="500" width="810px" @cancel="updateVal" @confirm="confirm" @close="updateVal">
      <!-- // 业务 -->
      <div v-for="(item, index) in skuList" :key="index" class="sku-item">
        <div class="sku-item-header">
          <el-row :gutter="10">
            <el-col :span="6">SKU编码：{{ item.skuCode }}</el-col>
            <el-col :span="11">SKU名称：{{ item.skuName }}</el-col>
            <el-col :span="7" style="text-align: right">
              <div v-if="activeSku && relationSku.indexOf(item.skuCode) > -1">
                <span>已关联：</span>
                <el-tag type="primary" closable size="small" @close="handleTagClose(item.skuCode)">{{ activeSku }}</el-tag>
              </div>
              <div v-else-if="skuList.length > 1" class="same-plan-box">
                <el-select
                  size="mini"
                  v-model="item.selectedSku"
                  multiple
                  collapse-tags
                  placeholder="请选择"
                  @focus="getSkuOptions(item)"
                  @change="getSkuChange(item)"
                >
                  <el-option v-show="!all" label="全部" value=""></el-option>
                  <el-option v-show="all" label="取消所有" value="cancleAll"></el-option>
                  <el-option v-for="item in skuOptions" :key="item.skuCode" :label="item.skuCode" :value="item.skuCode"> </el-option>
                </el-select>
                <el-button type="primary" size="small" plain @click="relationWithSku(item)">同计划</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="sku-item-form">
          <div class="relation-sku" v-if="activeSku === item.skuCode">
            <el-tag type="primary" v-for="(relatedCode, index) in relationSku" :key="index" closable size="small" @close="handleTagClose(relatedCode)">{{
              relatedCode
            }}</el-tag>
          </div>
          <el-form :model="item.form1" :inline="true" size="small" :disabled="relationSku.indexOf(item.skuCode) > -1">
            <el-tag type="warning" size="mini" class="form-tag">拍摄</el-tag>
            <!-- <el-form-item label="计划开始：">
              <el-date-picker
                v-model="item.form1.planStartTime"
                :picker-options="pickerOptions"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item> -->
            <el-form-item label="计划结束：">
              <el-date-picker v-model="item.form1.planEndTime" :picker-options="pickerOptions" type="date" placeholder="选择日期"> </el-date-picker>
            </el-form-item>
            <el-form-item label="计划人员：">
              <el-select v-model="item.form1.planPersonId" filterable="" placeholder="请选择">
                <el-option
                  v-for="item in captureUserList"
                  :key="item.userId"
                  :label="`${item.userName}${item.workNo ? '-' + item.workNo : ''}`"
                  :value="item.userId"
                >
                </el-option>
              </el-select>
              <!-- <el-input v-model.trim="item.form1.Id"></el-input> -->
            </el-form-item>
          </el-form>
          <el-form :model="item.form2" :inline="true" size="small" :disabled="relationSku.indexOf(item.skuCode) > -1">
            <el-tag type="warning" size="mini" class="form-tag">修片</el-tag>
            <!-- <el-form-item label="计划开始：">
              <el-date-picker
                v-model="item.form2.planStartTime"
                :picker-options="pickerOptions"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item> -->
            <el-form-item label="计划结束：">
              <el-date-picker v-model="item.form2.planEndTime" :picker-options="pickerOptions" type="date" placeholder="选择日期"> </el-date-picker>
            </el-form-item>
            <el-form-item label="计划人员：">
              <el-select v-model="item.form2.planPersonId" filterable="" placeholder="请选择">
                <el-option v-for="item in userList" :key="item.userId" :label="`${item.userName}${item.workNo ? '-' + item.workNo : ''}`" :value="item.userId">
                </el-option>
              </el-select>
              <!-- <el-input v-model.trim="item.form2.planPerson"></el-input> -->
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="tips">提示：每个SKU的计划必须要完整填写，才能够继续。<span>如有遗漏则该SKU无法进入下一步！</span></div>
    </q-dialog>
  </div>
</template>

<script>
import { newProductStepEnum } from '@/utils/constant';
import axios from '@/utils/axiosInstance';
import moment from 'moment';
export default {
  model: {
    prop: 'visible',
    event: 'input',
  },
  props: ['visible', 'spuCode'],
  data() {
    const ONE_DAY_MILLSECONDS = 24 * 60 * 60 * 1000;
    return {
      dialogVisible: false,
      // 业务
      skuList: [],
      form: {},
      activeSku: '',
      relationSku: [],
      loading: false,
      spuInfo: {},
      selectedSku: [],
      skuOptions: [],
      all: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - ONE_DAY_MILLSECONDS;
        },
      },
      userList: [],
      captureUserList: [],
    };
  },
  mounted() {
    this.dialogVisible = this.visible;
    this.getSpuInfo();
    this.getUserList();
    this.getCaptureUserList();
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout((_) => {
        this.$emit('input', false);
      }, 200);
    },
    getSkuChange(spu) {
      if (spu.selectedSku.includes('')) {
        spu.selectedSku = this.skuOptions.map((v) => v.skuCode);
        this.all = true;
      } else if (spu.selectedSku.includes('cancleAll')) {
        spu.selectedSku = [];
        this.all = false;
      }
    },
    checkValid() {
      const validSku = this.skuList.some((item) => {
        const { form1, form2 } = item;
        // 去掉了计划开始时间的校验，只需要计划结束时间和计划人员
        return !!form1.planEndTime && form1.planPersonId && !!form2.planEndTime && form2.planPersonId;
      });
      if (validSku) {
        return true;
      }
      this.$message.error('请至少将一个SKU的摄影计划填写完整。');
      return false;
    },
    confirm() {
      if (!this.checkValid()) {
        return false;
      }
      const params = [];
      this.skuList.forEach((item) => {
        params.push({
          ...item.form1,
          spuId: this.spuInfo.dataId,
          skuId: item.skuId,
          skuCode: item.skuCode,
          planStartTime: '', // 计划开始时间已被注释，传空字符串
          planEndTime: item.form1.planEndTime ? moment(item.form1.planEndTime).format('YYYY-MM-DD') : '',
          planPerson: item.form1.planPersonId ? this.captureUserList.find((v) => v.userId == item.form1.planPersonId).userName : '',
        });
        params.push({
          ...item.form2,
          spuId: this.spuInfo.dataId,
          skuId: item.skuId,
          skuCode: item.skuCode,
          planStartTime: '', // 计划开始时间已被注释，传空字符串
          planEndTime: item.form2.planEndTime ? moment(item.form2.planEndTime).format('YYYY-MM-DD') : '',
          planPerson: item.form2.planPersonId ? this.userList.find((v) => v.userId == item.form2.planPersonId).userName : '',
        });
      });
      this.$q.newProduct.savePlan({ data: params }).then(({ success }) => {
        if (success) {
          this.$notify.success({
            title: '成功',
            message: '保存摄影计划成功',
          });
          this.updateVal();
          this.$emit('success');
        }
      });
    },
    // 业务
    // 取消关联
    handleTagClose(skuCode) {
      this.relationSku = this.relationSku.filter((v) => v !== skuCode);
      const currentForm = this.skuList.find((item) => item.skuCode === skuCode);
      if (currentForm) {
        const basicForm = {
          planStartTime: '',
          planEndTime: '',
          planPersonId: '',
        };
        currentForm.form1 = {
          ...basicForm,
          taskId: newProductStepEnum.shooting,
        };
        currentForm.form2 = {
          ...basicForm,
          taskId: newProductStepEnum.retouching,
        };
      }
    },
    relationWithSku(sku) {
      if (!sku || !sku.selectedSku.length) {
        return;
      }
      // 不是第一次同步，需要弹框提醒
      // if(this.activeSku) {
      //   await this.$confirm('已有关联SKU，是否需要清空重新关联该SKU？', '提示')
      // }

      this.relationSku = [...sku.selectedSku];
      sku.selectedSku = [];

      this.activeSku = sku.skuCode;
      // 同步表单
      let mainSkuItem = this.skuList.find((v) => v.skuCode === this.activeSku);
      this.skuList.forEach((item) => {
        if (this.relationSku.includes(item.skuCode)) {
          // 直接引用同一个
          item.form1 = mainSkuItem.form1;
          item.form2 = mainSkuItem.form2;
        }
      });
    },
    getSpuInfo() {
      const params = {
        data: {
          pageNum: 1,
          pageSize: 1,
          filterData: {
            spuCode: this.spuCode,
          },
        },
      };
      this.loading = true;
      return this.$q.newProduct
        .listPage(params)
        .then(({ data }) => {
          this.spuInfo = (data && data.records && data.records[0]) || {};
          if (this.spuInfo.skuList && this.spuInfo.skuList.length) {
            this.skuList = this.spuInfo.skuList.map((item) => {
              const basicForm = {
                planStartTime: '',
                planEndTime: '',
                planPersonId: '',
              };
              return {
                skuId: item.dataId,
                skuCode: item.skuCode,
                skuName: item.skuName,
                selectedSku: [],
                form1: {
                  ...basicForm,
                  taskId: newProductStepEnum.shooting,
                },
                form2: {
                  ...basicForm,
                  taskId: newProductStepEnum.retouching,
                },
              };
            });
          }
        })
        .catch(console.log)
        .finally(() => {
          this.loading = false;
        });
    },
    getSkuOptions(sku) {
      this.all = false;
      sku.selectedSku = [];
      this.skuOptions = this.skuList.filter((item) => item.skuCode !== sku.skuCode);
    },
    getUserList() {
      let data = {
        pageSize: 999999,
        pageNum: 1,
        reportCode: 'getUserInfoByName',
      };
      axios.post(`/ec-pc-api/custom/reports/data/getUserInfoByName`, data).then((res) => {
        if (res.code == 200) {
          console.log(res.data);
          this.userList = res.data.list;
        }
      });
    },
    getCaptureUserList() {
      let data = {
        pageSize: 999999,
        pageNum: 1,
        reportCode: 'getShooterInfoByName',
      };
      axios.post(`/ec-pc-api/custom/reports/data/getShooterInfoByName`, data).then((res) => {
        if (res.code == 200) {
          this.captureUserList = res.data.list;
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
  >>> .el-dialog__content
    overflow-x hidden
  .sku-item
    margin-bottom 10px
  .sku-item-header
    margin-bottom 5px
    >>> .el-col
      line-height 24px
  .sku-item-form
    >>> .el-form-item
      margin-bottom 10px
    .relation-sku
      margin-bottom 5px
      >>> .el-tag+.el-tag
        margin-left 5px
  >>> .el-tag
    .el-tag__close
      background-color #0bb78e
      color #fff

  .slidex-enter
    transform translateX(100px)
    opacity 0
  .slidex-enter-active,.slidex-leave-active
    transition all linear .3s
    opacity 1
    position absolute
    >>> .el-button
      display inline-block
  .slidex-leave-to
    transform translateX(-100px)
    opacity 0

  .form-tag
    position relative
    top 6px

  .tips
    font-size 14px
    margin-top 10px
    color #999
    span
      color #E63946
  .same-plan-box
    display flex
    width 210px
    align-items center
    justify-content space-between
    >>> .el-button
      padding 7px 5px
      border-top-left-radius 0
      border-bottom-left-radius 0
    >>> .el-select__tags
      max-width 150px
    >>> .el-input
      .el-input__inner
        border-top-right-radius 0
        border-bottom-right-radius 0
        margin-right -1px
      .el-input__suffix
        right 0
        .el-input__icon
          width 20px

>>> .el-select__tags-text {
  display: inline-block;
  max-width: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
>>> .el-select .el-tag__close.el-icon-close {
  top: 0px;
  right: -4px
}
</style>
